import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AppPaginatorIntl extends MatPaginatorIntl {
  constructor(public translation: TranslateService) {
    super();
    this.translation.onLangChange.subscribe(() => {
      this.translateKeys();
    });

    this.translateKeys();
  }

  translateKeys(): void {
    const translations = this.translation.instant([
      '+GENERAL.PAGINATOR.ITEMS_PER_PAGE',
      '+GENERAL.PAGINATOR.NEXT_PAGE',
      '+GENERAL.PAGINATOR.PREVIOUS_PAGE',
    ]);
    this.itemsPerPageLabel = translations['+GENERAL.PAGINATOR.ITEMS_PER_PAGE'];
    this.nextPageLabel = translations['+GENERAL.PAGINATOR.NEXT_PAGE'];
    this.previousPageLabel = translations['+GENERAL.PAGINATOR.PREVIOUS_PAGE'];
  }

  getRangeLabel = function (page: number, pageSize: number, length: number): string {
    if (length === 0 || pageSize === 0) {
      return '0 of ' + length;
    }

    length = Math.max(length, 0);
    const startIndex = page * pageSize;

    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex =
      startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

    return startIndex + 1 + ' - ' + endIndex + ' of ' + length;
  };
}
